var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 69,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 71,
    width: 57,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#2058E7",
    d: "m53.86,21.1c-3.12,-13.89 -15.24,-20.1 -25.86,-20.1c0,0 0,0 -0.03,0c-10.59,0 -22.68,6.21 -25.83,20.07c-3.54,15.48 7.36,27.43 14.52,36.87c2.84,3.56 7.26,10.06 11.34,10.06c4.08,0 8.5,-6.3707 11.31,-10.06c7.19,-9.44 18.06,-21.36 14.55,-36.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "white",
    d: "m24.25,36.2499c-0.57,0 -1.14,-0.21 -1.59,-0.66l-4.5,-4.5c-0.87,-0.87 -0.87,-2.31 0,-3.18c0.87,-0.87 2.31,-0.87 3.18,0l2.91,2.91l10.41,-10.41c0.87,-0.87 2.31,-0.87 3.18,0c0.87,0.87 0.87,2.31 0,3.18l-12,12c-0.45,0.45 -1.02,0.66 -1.59,0.66z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerSelectedIcon);
export default __webpack_public_path__ + "static/media/MapMarkerSelectedIcon.6331a22f13999cfd0f5b007eac079fed.svg";
export { ForwardRef as ReactComponent };